module.exports = __webpack_public_path__ + "img/gold.589637c.jpg";